import { createContext, useContext } from "react";

/** Padding of a card's header, body and footer. `md` is today's look. */
export type CardSize = "sm" | "md";

/* The default is `md`, so a CardHeader, CardBody or CardFooter used outside a
   Card keeps today's padding. Every Card provides its own size, so a card
   nested in a `sm` card gets its own padding, not its parent's. */
export const CardSizeContext = createContext<CardSize>("md");

export function useCardSize(): CardSize {
  return useContext(CardSizeContext);
}

/** CardHeader and CardFooter padding. */
export const CARD_EDGE_PADDING: Record<CardSize, string> = {
  sm: "px-3 py-2",
  md: "px-4 py-3",
};

/** CardBody padding. */
export const CARD_BODY_PADDING: Record<CardSize, string> = {
  sm: "px-3 py-2.5",
  md: "px-4 py-4",
};
